import { type UseQueryResult, useQuery } from 'react-query';
import { PsuElectionWindowConfigurationService } from '../../services/wealthlane-award-settlement-services';
import { PsuAwardService } from '../../services/wealthlane-award-services';

const useGetPsuAwardPerformanceRuleDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  awardId: string,
  isApprover?: boolean
): any => {
  const psuAwardPerformanceRuleDetails = useQuery(
    ['getPsuAwardPerformanceRuleDetails'],
    async () => {
      if (awardId && !isApprover) {
        return await handleRequest(
          PsuAwardService.getApiAwardApiAppPSUAwardPerformanceRuleForAdminDetail(awardId)
        );
      }
    }
  );
  return psuAwardPerformanceRuleDetails;
};

export default useGetPsuAwardPerformanceRuleDetails;
